<template>
    <div class="lw-course-contents-chapter lw-padding-normal lw-bb-1px-fadeout80" @click="wrapperClicked" :class="sectionWrapperClass">
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-center">
            <div class="lw-course-contents-chapter-num col span_1_of_12 span_1_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp no-padding fsh-0">
                <h3 class="fsh-0 learnworlds-heading3 learnworlds-heading3-large no-margin-bottom learnworlds-element">
                    {{sectionNumber}}
                </h3>
            </div>
            <div class="col span_11_of_12 span_11_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp no-padding with-flexible-parts align-items-center justify-content-space-between">
                <div class="with-flexible-parts align-items-center">
                    <h3 class="learnworlds-heading3 learnworlds-heading3-large learnworlds-element lw-course-contents-chapter-name no-margin-bottom">{{sectionTitle}}</h3>
                    <div class="ml-10px lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny" v-if="displayAccessLabel && sectionAccess !== 'premium'">{{sectionDisplayedAccessLabel}}</div>

                    <!-- drip feed -->
                    <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                        <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                        <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
                    </div>
                    <!----->

                </div>
                <span class="ml-10px learnworlds-icon normal accordion-icon no-margin-bottom lw-text-color-fadeout50 fas"  :class="arrowClass"></span>
            </div>
        </div>
        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp mb-1rem" v-show="sectionDisplay">
            <div class="lw-course-contents-chapter-num col span_1_of_12 span_1_of_12-tl span_2_of_12-tp span_2_of_12-sl span_2_of_12-sp no-padding fsh-0">

            </div>
            <div class="lw-course-contents-units col span_11_of_12 span_11_of_12-tl span_10_of_12-tp span_10_of_12-sl span_10_of_12-sp no-padding">

                <div class="lw-course-contents-unit with-flexible-parts align-items-center p-5px-0 " v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">

                    <unit-icon class="lw-contents-svg normal" :icon="unit.icon"></unit-icon>

                    <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                        {{unit.title}}
                    </div>
                    <div class="hide-sp ml-10px no-margin-bottom lw-text-color-fadeout50 learnworlds-main-text learnworlds-main-text-normal learnworlds-element" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">
                        {{getUnitExtraInfo(unit)}}
                    </div>
                    <span class="ml-10px no-margin-bottom learnworlds-main-text-normal learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
                    <span class="ml-10px no-margin-bottom learnworlds-main-text-normal learnworlds-icon fas fa-check" v-if="unitCompleted(unit)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate16",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin],
        props: {
            sectionsDisplay: {
                type: Object
            }
        },
        computed: {
            arrowClass () {
                return {
                    "fa-angle-down" : !this.sectionDisplay,
                    "fa-angle-up" : this.sectionDisplay,
                }
            },
            sectionDisplay () {
                return this.sectionsDisplay && this.sectionsDisplay[this.sectionData.titleId] ? true : false;
            }
        },
        methods: {
            wrapperClicked () {
                this.sectionClicked();
                this.emitAction('set-section-display' , !this.sectionDisplay);
            }
        }
    }
</script>

